<div class="height100p flex-col-fixed-fill">
    <sm-toolbar>
        <p-button severity="success" icon="fas fa-save" label="Speichern" (onClick)="saveInternal()">
        </p-button>
        <p-button severity="secondary" icon="fas fa-times" label="Abbrechen" (onClick)="cancel()">
        </p-button>
    </sm-toolbar>
    <p-card>
        <sm-form class="height100p" [form]="form">
        </sm-form>
    </p-card>
</div>
